import { Controller } from "@hotwired/stimulus"

// Note subject title ↔ field toggle. Edit/save controls live in the top and
// bottom action rows (not beside the subject).
export default class extends Controller {
  static targets = ["display", "form", "input", "editButton", "saveButton"]

  edit(event) {
    event.preventDefault()
    this.displayTargets.forEach((el) => el.classList.add("hidden"))
    this.formTarget.classList.remove("hidden")
    this.editButtonTargets.forEach((el) => {
      el.hidden = true
    })
    this.saveButtonTargets.forEach((el) => {
      el.hidden = false
    })
    if (this.hasInputTarget) {
      const input = this.inputTarget
      input.focus()
      input.select()
    }
  }
}
